module.exports = "/images/vendor/flag-icon-css/flags/1x1/mu.svg?67c8f3621446645a9008ef039b0dbc69";